import React, { useEffect, useMemo, useState } from "react";
import { Button, Grid } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Account from "./Account";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { DashboardAcHeading, filterAccount, filterActiveAc } from "../../../store/reducers/dashboardReducer";

const FilterIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#010101" />
    <path
      d="M17.5 22.625C17.9142 22.625 18.25 22.2892 18.25 21.875C18.25 21.4608 17.9142 21.125 17.5 21.125V22.625ZM10.5 21.125C10.0858 21.125 9.75 21.4608 9.75 21.875C9.75 22.2892 10.0858 22.625 10.5 22.625L10.5 21.125ZM17.5 12.375C17.0858 12.375 16.75 12.7108 16.75 13.125C16.75 13.5392 17.0858 13.875 17.5 13.875V12.375ZM24.5 13.875C24.9142 13.875 25.25 13.5392 25.25 13.125C25.25 12.7108 24.9142 12.375 24.5 12.375V13.875ZM17.5 21.125L10.5 21.125L10.5 22.625L17.5 22.625V21.125ZM17.5 13.875L24.5 13.875V12.375L17.5 12.375V13.875ZM9.75 13.125C9.75 14.5057 10.8693 15.625 12.25 15.625V14.125C11.6977 14.125 11.25 13.6773 11.25 13.125H9.75ZM12.25 15.625C13.6307 15.625 14.75 14.5057 14.75 13.125H13.25C13.25 13.6773 12.8023 14.125 12.25 14.125V15.625ZM14.75 13.125C14.75 11.7443 13.6307 10.625 12.25 10.625V12.125C12.8023 12.125 13.25 12.5727 13.25 13.125H14.75ZM12.25 10.625C10.8693 10.625 9.75 11.7443 9.75 13.125H11.25C11.25 12.5727 11.6977 12.125 12.25 12.125V10.625ZM25.25 21.875C25.25 20.4943 24.1307 19.375 22.75 19.375V20.875C23.3023 20.875 23.75 21.3227 23.75 21.875H25.25ZM22.75 19.375C21.3693 19.375 20.25 20.4943 20.25 21.875H21.75C21.75 21.3227 22.1977 20.875 22.75 20.875V19.375ZM20.25 21.875C20.25 23.2557 21.3693 24.375 22.75 24.375V22.875C22.1977 22.875 21.75 22.4273 21.75 21.875H20.25ZM22.75 24.375C24.1307 24.375 25.25 23.2557 25.25 21.875H23.75C23.75 22.4273 23.3023 22.875 22.75 22.875V24.375Z"
      fill="#8F8F8F"
    />
  </svg>
);

const AddIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#010101" />
    <path
      d="M10.5 17.5H24.5M17.5 24.5V17.5L17.5 10.5"
      stroke="#04D9FF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const AccountTypeIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#010101" />
    <path
      d="M12.25 20.25H22.75"
      stroke="#04D9FF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.25 17.5H22.75"
      stroke="#04D9FF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.25 14.75H22.75"
      stroke="#04D9FF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const ActiveAccounts = ({ data , theme }) => {
  const navigate = useNavigate();
  const dashboardFilters = ["All", "Active", "Inactive"];
  const [statusFilter, setStatusFilter] = useState(dashboardFilters[0]);
  const [accountTypeFilter, setAccountTypeFilter] = useState("All");
  const dispatch = useDispatch();

  const { dashboardAcHeading, filteredActiveAc, filteredbyaccount } = useSelector(state => state.dashboard);


  const [currentAccountsTitle, setCurrentAccountsTitle] = useState(dashboardFilters[0]);

  const FilterData = data?.filter((item) => filteredbyaccount === 'All' ? item : item?.status?.toLowerCase() === filteredbyaccount?.toLowerCase())

  const displayAccounts = useMemo(() => {
    return (
      data &&
      Array.isArray(data) &&
      FilterData.filter((item) => {
        if (filteredActiveAc === null || filteredActiveAc === "all") return true;
        if (filteredActiveAc === "active") return item.is_active === true;
        if (filteredActiveAc === "inactive") return item.is_active === false;
      }).filter((item) => {
        if (filteredbyaccount === "All") return true;
        return item.status === filteredbyaccount;
      })
    );
  }, [data, statusFilter, accountTypeFilter, filteredActiveAc, filteredbyaccount]);

  // Filter Menu States for Status
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const statusOpen = Boolean(statusAnchorEl);

  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };


  useEffect(() => {
    if (!filteredActiveAc) {
      dispatch(filterActiveAc('active'))
    }
  }, [dispatch])

  useEffect(() => {
    if (!filteredbyaccount) {
      dispatch(filterAccount('All')); 
      dispatch(DashboardAcHeading(`All Accounts`));  
    }
  }, []);

  const handleStatusClose = (value) => {
    setStatusAnchorEl(null);
    if (typeof value === "string") {
      setStatusFilter(value);
      if (value === "Active") {
        dispatch(filterActiveAc("active"));
        setCurrentAccountsTitle("Active Accounts");
        dispatch(DashboardAcHeading(`${filteredbyaccount === 'Evaluation' ? 'Alpha Pro' : filteredbyaccount}  Active Accounts`))
      } else if (value === "Inactive") {
        dispatch(filterActiveAc("inactive"));
        setCurrentAccountsTitle("Inactive Accounts");
        dispatch(DashboardAcHeading(`${filteredbyaccount === 'Evaluation' ? 'Alpha Pro' : filteredbyaccount}  Inactive Accounts`))
      } else {
        dispatch(filterActiveAc("all"));
        setCurrentAccountsTitle("All Accounts");
        dispatch(DashboardAcHeading(`${filteredbyaccount === 'Evaluation' ? 'Alpha Pro' : filteredbyaccount}  Accounts`))
      }
    }
  };

  // Filter Menu States for Account Types
  const [typeAnchorEl, setTypeAnchorEl] = useState(null);
  const typeOpen = Boolean(typeAnchorEl);

  const handleTypeClick = (event) => {
    setTypeAnchorEl(event.currentTarget);
  };

  const handleTypeClose = (value) => {
    setTypeAnchorEl(null);
    if (typeof value === "string") {
      setAccountTypeFilter(value);
      dispatch(DashboardAcHeading(`${value} ${filteredActiveAc} Accounts`))
      dispatch(filterAccount(value === 'Competition' ? 'Competition' : value))
    }
  };

  function DashboardHeadingText() {
    const words = dashboardAcHeading?.split(/\s+/);
    const wordMap = {};
    const uniqueWords = words?.filter(word => {
      if (!wordMap[word.toLowerCase()]) {
        wordMap[word.toLowerCase()] = true;
        return true;
      }
      return false;
    });
    const result = uniqueWords?.join(" ").trim().toUpperCase();

    return result?.charAt(0).toUpperCase() + result?.slice(1);
  }

  return (
    <Grid className="active-accounts-ctn" container item xs={6} md={12}>
      <Grid className="acc" item xs={12}>
        <div className="card Bgrey">
          <div className="d-flex aa-header ">
            <div className="text-gray">
              {DashboardHeadingText()}
            </div>
            <div className="toolbar pill" style={{ gap: "10px" }}>
              {/* Status Filter Dropdown */}
              <Button onClick={handleStatusClick}>{FilterIcon}</Button>
              <Menu
                className="accounts-menu-wrapper"
                id="status-menu"
                anchorEl={statusAnchorEl}
                open={statusOpen}
                onClose={handleStatusClose}
                MenuListProps={{
                  "aria-labelledby": "status-button",
                }}
              >
                {dashboardFilters.map((filter) => (
                  <MenuItem
                    key={filter}
                    onClick={() => handleStatusClose(filter)}
                  >
                    {filter}
                  </MenuItem>
                ))}
              </Menu>

              {/* Account Type Filter Dropdown */}
              <Button onClick={handleTypeClick}>{AccountTypeIcon}</Button>
              <Menu
                className="account-types-menu-wrapper"
                id="account-types-menu"
                anchorEl={typeAnchorEl}
                open={typeOpen}
                onClose={handleTypeClose}
                MenuListProps={{
                  "aria-labelledby": "account-types-button",
                }}
              >
                {["Alpha", "Competition", "Free Trial", "All"].map((type) => (
                  <MenuItem key={type} onClick={() => {
                    handleTypeClose(type === 'Alpha' ? 'Evaluation' : type)
                    dispatch(DashboardAcHeading(`${type === 'Alpha' ? 'Alpha Pro' : type} ${filteredActiveAc === 'All' ? '' : filteredActiveAc} Accounts`))
                  }}>
                    {type}
                  </MenuItem>
                ))}
              </Menu>

             
              <Button
                className="add-acc-btn"
                onClick={() => navigate("/FundingEvaluation")}
                startIcon={AddIcon}
              >
                Add Account
              </Button>
            </div>
          </div>
          <div className="acc-list" style={{ gap: "2rem" }}>
            {displayAccounts?.length > 0 ?
              displayAccounts?.map((item, idx) => (
                <Account data={item} key={idx} theme={theme}/>
              )) : <h1 style={{ position: 'absolute', top: '160%', left: '50%', transform: 'translate(-50%,-50%)', fontSize: '22px', letterSpacing: '1px', color: 'rgb(4,217,255)' }}>{`No data.`}</h1>}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default ActiveAccounts;
